import { Merchant } from "client/lib/apt-merchant";

export const getEmail = (merchant: Merchant): string => {
  if (merchant.lead.email.value) {
    return merchant.lead.email.value;
  }

  const localStorageEmail = localStorage.getItem("email");

  if (localStorageEmail !== null) {
    return localStorageEmail;
  }

  return "";
};
